import React from "react";
import logo from "../../../assets/svgs/avatr/avatr-wordmark.svg";

interface Props {
  title: string;
  subtitle: string;
}

const SidebarHeader: React.FC<Props> = ({ title, subtitle}) => {
  
  return (
    <div className="studio-sidebar-header">
      <img className={`studio-sidebar-header-logo`} src={logo} alt="" />
      <div className='studio-sidebar-header-title'>{title}</div>
      <div className='studio-sidebar-header-subtitle'>{subtitle}</div>
    </div>
  );
};

export default SidebarHeader;